var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st-accent{fill:#ed0000;}.st-plate{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st-plate",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11h22a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H19l-6 5v-5H9a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st-accent",
    d: "M18 23h21a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-3v5l-7-5H18a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.d9bd67cb46b8d20eca88921cee34f858.svg";
export { ForwardRef as ReactComponent };